import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuperAdminService } from '../../../services/super-admin/super-admin.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// create or edit a view (a menu / screen node). On edit the view name is
// immutable (matches the backend). data = { view, views } — views is the list
// used for the parent-view picker; view is present only when editing.
@Component({
  selector: 'app-sa-view-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './sa-view-dialog.component.html',
  styleUrls: ['./sa-view-dialog.component.scss', '../../../../common-style/dropdown.scss', '../../../../common-style/ac-dialog.scss'],
})
export class SaViewDialogComponent implements OnInit {
  form: FormGroup;
  isEdit: boolean = false;
  isLoading: boolean = false;
  parents: any[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SaViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { view?: any; views?: any[] },
    private superAdminService: SuperAdminService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      viewName: ['', Validators.required],
      viewLabel: ['', Validators.required],
      parentViewId: [null],
      level: [1, Validators.required],
      displayOrder: [0, Validators.required],
      viewType: ['T', Validators.required],
      applicableFor: ['ESTABLISHMENT', Validators.required],
      webRoute: [''],
      appRoute: [''],
      icon: [''],
      iconActive: [''],
      appIcon: [''],
      viewMode: [''],
      status: [1],
    });
  }

  ngOnInit(): void {
    this.parents = (this.data?.views || []).filter((v) => v.viewType === 'C');
    const view = this.data?.view;
    if (view) {
      this.isEdit = true;
      this.parents = this.parents.filter((v) => v.viewId !== view.viewId); // can't parent itself
      this.form.patchValue({
        viewName: view.viewName,
        viewLabel: view.viewLabel,
        parentViewId: view.parentViewId,
        level: view.level,
        displayOrder: view.displayOrder,
        viewType: view.viewType,
        applicableFor: view.applicableFor,
        webRoute: view.webRoute,
        appRoute: view.appRoute,
        icon: view.icon,
        iconActive: view.iconActive,
        appIcon: view.appIcon,
        viewMode: view.viewMode,
        status: view.status,
      });
      this.form.get('viewName')?.disable(); // name is immutable on edit
    }
  }

  submit(): void {
    if (this.form.invalid) {
      this.toastService.error('Name, label, level, order, type and applicable-for are required.');
      return;
    }
    this.isLoading = true;
    const payload = this.form.getRawValue();
    const view = this.data?.view;
    const request$ = this.isEdit
      ? this.superAdminService.updateView(view.viewId, payload)
      : this.superAdminService.createView(payload);
    request$.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Saved.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save view.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
